// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-app-header-Rewards-module__root--3w-Es","label":"src-components-app-header-Rewards-module__label--ibedh"};